import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ISetLocationPageParams } from '../../actions/location';
import { getOffersData } from '../../actions/offersData';
import { Footer } from '../../components/Footer';
import { Pagination } from '../../components/Pagination';
import {
  NEWBUILDINGS_GK_SUGGEST_COUNT,
  PATH_PREFIX_NON_FIRST_PAGE,
  QUERY_PARAM_NAME_PAGE,
} from '../../constants/config';
import { TTypedThunkDispatch } from '../../types/thunk';
import { PrintButtonContainer } from '../PrintButton';
import { selectCanUseHiddenBase } from '../../selectors/user';
import { getCurrentPage } from '../../selectors/location/getCurrentPage';
import { selectGeoPath } from '../../selectors/location/selectGeoPath';
import { selectSeoQuery } from '../../selectors/seo';
import { selectQueryString, selectTotal } from '../../selectors/offersData';
import { IPaginationOnClickParams } from '../../components/Pagination/PaginationLink';
import { incrementAnimationCounter } from '../../actions/consultantCianChat';

export const OffersFooterContainer: React.FC = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const canUseHiddenBase = useSelector(selectCanUseHiddenBase);
  const currentPage = useSelector(getCurrentPage);
  const geoPath = useSelector(selectGeoPath);
  const seoQuery = useSelector(selectSeoQuery);
  const queryString = useSelector(selectQueryString);
  const total = useSelector(selectTotal) || 0;
  const finalQueryString = seoQuery || queryString;
  const maxPage = Math.ceil(total / NEWBUILDINGS_GK_SUGGEST_COUNT);
  const shouldShowPagination = Boolean(maxPage && maxPage > 1);

  const setPage = useCallback(
    (params: ISetLocationPageParams) => {
      dispatch(getOffersData(params));
    },
    [dispatch],
  );

  const urlCreator = useCallback(
    (page: number) => {
      const query = (finalQueryString && `${finalQueryString}&`) || '';
      const url = `${geoPath ? `/${geoPath}` : ''}/${PATH_PREFIX_NON_FIRST_PAGE}?${query}${QUERY_PARAM_NAME_PAGE}=${page}`;

      return url;
    },
    [finalQueryString, geoPath],
  );

  const onClick = React.useCallback(
    ({ page, url }: IPaginationOnClickParams) => {
      setPage({ page, path: url, canUseHiddenBase });
      dispatch(incrementAnimationCounter());
    },
    [canUseHiddenBase, dispatch, setPage],
  );

  return (
    <Footer
      pagination={
        shouldShowPagination && (
          <Pagination currentPage={currentPage} maxPage={maxPage} urlCreator={urlCreator} onClick={onClick} />
        )
      }
      printButton={<PrintButtonContainer />}
    />
  );
};
